<template>
    <div class="dropdown" :class="{active: isOpen, open: mobileView, 'single-choice': isSingleChoice}" v-click-outside="onClickOutside" :style="{width: width + 'px'}">
        <div class="selected"  @click="toggle">
            <span v-html="template"></span>
            <Chevron class="arrow" v-if="!mobileView"/>
        </div>
        <div class="options" v-if="options" v-show="isOpen || mobileView">
            <div class="option" :class="{active: filterselected.includes(option)}" v-for="option in options" @click="set(option)">
                <div class="checkbox-label" v-if="mobileView">
                    <Check v-if="filterselected.includes(option)"/>
                </div>
                {{ option }}
                <Check v-if="!mobileView" class="check-icon" :class="{'-visible': filterselected.includes(option)}"/>
            </div>
        </div>
    </div>
</template>

<script>
import Chevron from "./icons/IconChevron.vue";
import Check from "./icons/IconCheck.vue";
Vue.directive("click-outside", {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});
export default {
    name: "Dropdown",
    props: ['name', 'filterValue', 'options', 'filterselected', 'mobileView', 'width', 'isSingleChoice', 'hasPlaceholder'],
    emits: ['setSelection'],
    data: function() {
        return {
            isOpen: false,
            selected: this.filterselected
        }
    },
    watch: {
        filterselected(){
            this.selected = this.filterselected
        }
    },
    computed: {
        template() {
            if(this.isSingleChoice) {
                return this.selected || `<span class="dropdown-placeholder">${this.name}</span>`
            } else {
                return this.name
            }
        }
    },
    methods: {
        toggle: function() {
            if(!this.mobileView){
                this.isOpen = !this.isOpen;
            }
        },
        hide: function() {
            this.isOpen = false;
        },
        set: function(option) {
            if (this.isSingleChoice) {
                this.selected = option;
                this.$emit('setSelection', this.selected);
                this.hide();
            } else {
                if (this.selected.includes(option)){
                    this.selected = this.selected.filter(el => el !== option);
                } else {
                    this.selected.push(option);
                }
                this.$emit('setSelection', this.filterValue, this.selected)
            }
        },
        onClickOutside () {
            this.hide()
        },
    },
    components: {Chevron, Check}
}
</script>
<style lang="scss">
@import "../../../sass/front/helpers";

.dropdown-placeholder {
    color: rgba(37, 37, 37, 0.67);
}
.dropdown.single-choice .selected {
    font-size: 14px;
}
.checkbox-label {
    width: 24px;
    min-width: 24px;
    height: 24px;
    border: solid 1px #121A26;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    @include responsive-below($sm) {
        width: 21px;
        min-width: 21px;
        height: 21px;
    }
}

@include responsive-below($sm) {
    .checkbox-title {
        font-size: 12px;
        font-weight: 300;
    }
}

.dropdown.active .checkbox-label {
    background: $color-brand;
    color: #fff;
}

.check-icon {
    opacity: 0;
    visibility: hidden;
    min-width: 16px;

    &.-visible {
        opacity: 1;
        visibility: visible;
    }
}
</style>
